import Vue from 'vue'
import { Mutation as VuexMutation, MutationTree } from 'vuex'
import { DueTask, Gateway, ModuleState, Process, TaskLog, MyDate } from './types'

export const mutations: MutationTree<ModuleState> = {}

mutations.setLoading = (state, payload: boolean) => {
  state.loading = payload
}

export interface SetMyDateMutation {
  type: 'setMyDates' | 'workflow/setMyDates'
  dates: MyDate[]
}

mutations.setMyDates = (state, { dates }: SetMyDateMutation) => {
  Vue.set(state, 'myDates', dates)
}

export interface AddTaskLogMutation {
  type: 'addTaskLog' | 'workflow/addTaskLog'
  tasks: TaskLog[]
}

mutations.addTaskLog = (state, { tasks }: AddTaskLogMutation) => {
  tasks.forEach(task => {
    Vue.set(state.taskLog, task.id, task)
  })
}

export interface AddGatewayMutation {
  type: 'addGateway' | 'workflow/addGateway'
  gateways: Gateway[]
}

mutations.addGateway = (state, { gateways }: AddGatewayMutation) => {
  gateways.forEach(gateway => {
    Vue.set(state.gateways, gateway.id, gateway)
  })
}

export interface AddProcessesMutation {
  type: 'addProcesses' | 'workflow/addProcesses'
  processes: Process[]
}

mutations.addProcesses = (state, { processes }: AddProcessesMutation) => {
  processes.forEach(task => {
    Vue.set(state.processes, task.id, task)
  })
}

export interface AddProcessLogMutation {
  type: 'addProcessLog' | 'workflow/addProcessLog'
  processes: Process[]
}

mutations.addProcessLog = (state, { processes }: AddProcessLogMutation) => {
  processes.forEach(task => {
    Vue.set(state.processLog, task.id, task)
  })
}

export interface DropDueTasks {
  type: 'dropDueTasks' | 'workflow/dropDueTasks'
  tasks: Array<Pick<DueTask, 'id'>>
}

mutations.dropDueTasks = (state, { tasks }: DropDueTasks) => {
  tasks.forEach(task => {
    Vue.delete(state.taskLog, task.id)
  })
}

export interface DropProcesses {
  type: 'dropProcesses' | 'workflow/dropProcesses'
  processes: Array<Pick<Process, 'id'>>
}

mutations.dropProcesses = (state, { processes }: DropProcesses) => {
  console.log('drop', processes)
  processes.forEach(process => {
    Vue.delete(state.processes, process.id)
  })
}

export interface ResetStateMutation {
  type: 'resetState' | 'workflow/resetState'
}

mutations.resetState = (state, {}: ResetStateMutation) => {
  state.loading = false
  state.taskLog = {}
  state.processes = {}
  state.gateways = {}
  state.processLog = {}
}

export type Mutation =
  | AddTaskLogMutation
  | AddGatewayMutation
  | AddProcessesMutation
  | AddProcessLogMutation
  | DropDueTasks
  | DropProcesses
  | ResetStateMutation

export default mutations
